import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

import { useParams } from "react-router-dom";

export const MonitoringDetailContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MonitoringDetailProvider: FunctionComponent<Props> = ({ children }) => {
  const { id } = useParams();

  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["monitoring_detail"],
    // staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/transactions/${id}/monitor-details`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <MonitoringDetailContext.Provider value={contextValue}>
      {children}
    </MonitoringDetailContext.Provider>
  );
};

export default MonitoringDetailProvider;
